module.exports = __webpack_public_path__ + "img/20210906-1630913628416641.00de6bec.png";